import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import Swal from "sweetalert2";

import { Utils } from "../../../../../shared/utils/Utils";
import {
  Queja,
  QuejaPayload,
  QuejasService,
} from "../../../../../shared/services/quejas.service";
// TODO: ajusta el path/nombre real de tu servicio de colaboradores.
// Se asume una forma similar a CargosService (getColaboradoresActivos()).
import { ColaboradoresService } from "../../../../../shared/services/colaboradores.service";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";
import { TipoQuejaService } from "../../../../../shared/services/tipo-queja.service";
import { OrigenQuejasService } from "../../../../../shared/services/origen-quejas.service";
import { SeguimientosQuejasComponent } from "./seguimientos-quejas/seguimientos-quejas/seguimientos-quejas.component";
import { EstadoPlanAccion, EstadoPlanAccionService } from "../../../../../shared/services/estado-plan-accion.service";

interface QuejaFormValue {
  id_colaborador: number | null;
  tipo: string;
  fecha_queja: string;
  origen: string;
  motivo: string;
  respuesta: string | null;
  fecha_respuesta: string | null;
  estado_gestion: string;
  documento_id: number | null;
}

@Component({
  selector: "app-quejas",
  templateUrl: "./quejas.component.html",
  styleUrls: ["./quejas.component.scss"],
})
export class QuejasComponent implements OnInit {
  quejaForm!: FormGroup;
  activeTab = 1;

  guardando = false;
  cargandoListado = false;
  cargandoEdicion = false;
  cargandoColaboradores = false;
  cargandoTipoQuejas = false;
  cargandoOrigenQuejas = false;
  cargandoEstadosPlan = false;

  quejas: Queja[] = [];
  quejasFiltradas: Queja[] = [];
  colaboradores: any[] = [];
  tipoquejas: any[] = [];
  origenquejas: any[] = [];

  filtro = "";
  filtroEstado: number | null = null;
  filtroEstadoGestion = "";
  pageSize = 10;
  page = 1;

  // Estado de edición dentro del mismo formulario
  modoEdicion = false;
  idQuejaEditando: number | null = null;


  estadosPlan: EstadoPlanAccion[] = [];

  readonly Number = Number;

  // Antes existía "modalService: any" sin asignar, lo que rompía verSeguimiento() en tiempo de ejecución
  constructor(
    private fb: FormBuilder,
    private quejasService: QuejasService,
    private propietarioService: PropietarioService,
    private tipoQuejaService: TipoQuejaService,
    private origenQuejasService: OrigenQuejasService,
    private modalService: NgbModal,
    private estadoPlanAccionService: EstadoPlanAccionService,
  ) {}

  ngOnInit(): void {
    this.inicializarFormulario();
    this.cargarColaboradores();
    this.cargarQuejas();
    this.cargarTipoQueja();
    this.cargarOrigenQueja();
    this.cargarEstadosPlan();
  }

  private inicializarFormulario(): void {
    this.quejaForm = this.fb.group({
      id_colaborador: [null, Validators.required],
      tipo: [null, Validators.required],
      fecha_queja: ["", Validators.required],
      origen: [null, Validators.required],
      motivo: ["", [Validators.required, Validators.maxLength(1000)]],
      respuesta: [null],
      fecha_respuesta: [null],
      estado_gestion: [null, Validators.required],
      documento_id: [null],
    });
  }

  // ============ CATÁLOGOS ============
  
private cargarColaboradores(): void {
  this.cargandoColaboradores = true;

  this.propietarioService
    .getPlanAccion()
    .pipe(
      catchError(() => of([]))
    )
    .subscribe({
      next: (response: any) => {
        this.colaboradores = this.normalizarLista(response).map(
          (colaborador: any) => ({
            ...colaborador,
            nombreCompleto: colaborador.nombreCompleto ?? '',
            cargo: colaborador.cargoData?.cargos ?? ''
          })
        );

        this.cargandoColaboradores = false;
      },
      error: () => {
        this.colaboradores = [];
        this.cargandoColaboradores = false;
      }
    });
}

  private cargarEstadosPlan(): void {
    this.cargandoEstadosPlan = true;
    this.estadoPlanAccionService.getEstados().subscribe({
      next: (response: any) => {
        this.estadosPlan = Array.isArray(response) ? response : response?.data || [];
        this.cargandoEstadosPlan = false;
      },
      error: () => {
        this.estadosPlan = [];
        this.cargandoEstadosPlan = false;
      },
    });
  }

    private cargarTipoQueja(): void {
    this.cargandoTipoQuejas = true;
    this.tipoQuejaService
      .getAll()
      .pipe(catchError(() => of([])))
      .subscribe((response: any) => {
        this.tipoquejas = this.normalizarLista(response);
        this.cargandoTipoQuejas = false;
      });
  }

    private cargarOrigenQueja(): void {
    this.cargandoOrigenQuejas = true;
    this.origenQuejasService
      .getAll()
      .pipe(catchError(() => of([])))
      .subscribe((response: any) => {
        this.origenquejas = this.normalizarLista(response);
        this.cargandoOrigenQuejas = false;
      });
  }

  // ============ LISTADO ============

  cargarQuejas(): void {
    this.cargandoListado = true;

    this.quejasService.getAll().subscribe({
      next: (response: any) => {
        this.quejas = this.normalizarLista(response);
        this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: () => {
        this.quejas = [];
        this.quejasFiltradas = [];
        this.cargandoListado = false;
      },
    });
  }

  private normalizarLista(response: any): any[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    return [];
  }

  aplicarFiltro(): void {
    const termino = String(this.filtro || "")
      .toLowerCase()
      .trim();

    let filtradas = this.quejas.filter((queja: any) => {
      const coincideTexto =
        !termino ||
        [queja.motivo, queja.tipo, queja.origen, queja?.ColaboradorData?.nombre]
          .filter((valor) => valor !== null && valor !== undefined)
          .some((valor) => String(valor).toLowerCase().includes(termino));

      const estadoQueja = Number(queja.estado);
      const coincideEstado =
        this.filtroEstado === null || estadoQueja === this.filtroEstado;

      const coincideGestion =
        !this.filtroEstadoGestion ||
        String(queja.estado_gestion) === this.filtroEstadoGestion;

      return coincideTexto && coincideEstado && coincideGestion;
    });

    filtradas = filtradas.sort((a: any, b: any) => {
      const estadoA = Number(a.estado) === 1 ? 0 : 1;
      const estadoB = Number(b.estado) === 1 ? 0 : 1;
      if (estadoA !== estadoB) return estadoA - estadoB;
      return (b.id || 0) - (a.id || 0);
    });

    this.quejasFiltradas = filtradas;
    this.page = 1;
  }

  // ============ GUARDAR (CREAR / ACTUALIZAR) ============

  guardar(): void {
    if (this.quejaForm.invalid) {
      this.quejaForm.markAllAsTouched();
      Swal.fire(
        "Campos obligatorios",
        "Completa todos los campos requeridos.",
        "warning",
      );
      return;
    }

    if (this.modoEdicion) {
      this.actualizarQueja();
      return;
    }

    const formValue = this.quejaForm.getRawValue() as QuejaFormValue;

    const payload: QuejaPayload = {
      id_colaborador: Number(formValue.id_colaborador),
      tipo: String(formValue.tipo || "").trim(),
      fecha_queja: formValue.fecha_queja,
      origen: String(formValue.origen || "").trim(),
      motivo: String(formValue.motivo || "").trim(),
      respuesta: formValue.respuesta ? String(formValue.respuesta).trim() : null,
      fecha_respuesta: formValue.fecha_respuesta || null,
      estado_gestion: formValue.estado_gestion,
      documento_id:
        formValue.documento_id !== null && formValue.documento_id !== undefined
          ? Number(formValue.documento_id)
          : null,
      estado: 1,
    };

    this.guardando = true;

    this.quejasService.create(payload).subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Éxito", "Queja guardada correctamente.", "success");
        this.resetearFormularioCreacion();
        this.cargarQuejas();
        this.activeTab = 2;
      },
      error: (error: any) => {
        this.guardando = false;
        const mensaje = error?.error?.error || "No se pudo guardar la queja.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  private actualizarQueja(): void {
    if (!this.idQuejaEditando) {
      Swal.fire("Error", "No hay una queja seleccionada para editar.", "error");
      return;
    }

    const formValue = this.quejaForm.getRawValue() as QuejaFormValue;

    const payload: Partial<QuejaPayload> = {
      id_colaborador: Number(formValue.id_colaborador),
      tipo: String(formValue.tipo || "").trim(),
      fecha_queja: formValue.fecha_queja,
      origen: String(formValue.origen || "").trim(),
      motivo: String(formValue.motivo || "").trim(),
      respuesta: formValue.respuesta ? String(formValue.respuesta).trim() : null,
      fecha_respuesta: formValue.fecha_respuesta || null,
      estado_gestion: formValue.estado_gestion,
      documento_id:
        formValue.documento_id !== null && formValue.documento_id !== undefined
          ? Number(formValue.documento_id)
          : null,
    };

    this.guardando = true;

    this.quejasService.update(this.idQuejaEditando, payload).subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Éxito", "Queja actualizada correctamente.", "success");
        this.cancelarEdicion();
        this.cargarQuejas();
        this.activeTab = 2;
      },
      error: (error: any) => {
        this.guardando = false;
        const mensaje = error?.error?.error || "No se pudo actualizar la queja.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  private resetearFormularioCreacion(): void {
    this.quejaForm.reset({
      id_colaborador: null,
      tipo: "",
      fecha_queja: "",
      origen: "",
      motivo: "",
      respuesta: null,
      fecha_respuesta: null,
      estado_gestion: null,
      documento_id: null,
    });
  }

  // ============ EDITAR (carga datos en el formulario) ============

  editarQueja(queja: Queja): void {
    if (Number(queja?.estado) !== 1) {
      Swal.fire("Info", "Solo se puede editar cuando el registro está activo.", "info");
      return;
    }

    const id = Number(queja?.id);
    if (!id) {
      Swal.fire("Error", "No se encontró el id de la queja.", "error");
      return;
    }

    this.cargandoEdicion = true;

    this.quejasService.getById(id).subscribe({
      next: (response: any) => {
        this.cargandoEdicion = false;

        const data = (response as any)?.data ?? response;
        if (!data) {
          Swal.fire("Error", "No se pudo cargar la información de la queja.", "error");
          return;
        }

        this.modoEdicion = true;
        this.idQuejaEditando = id;

        this.quejaForm.patchValue({
          id_colaborador: data?.id_colaborador ?? null,
          tipo: data?.tipo ?? "",
          fecha_queja: data?.fecha_queja ?? "",
          origen: data?.origen ?? "",
          motivo: data?.motivo ?? "",
          respuesta: data?.respuesta ?? null,
          fecha_respuesta: data?.fecha_respuesta ?? null,
          // El ng-select usa bindValue "id" (numérico); hay que castear para que coincida con estadosPlan
          estado_gestion:
            data?.estado_gestion !== null && data?.estado_gestion !== undefined
              ? Number(data.estado_gestion)
              : null,
          documento_id: data?.documento_id ?? null,
        });

        this.activeTab = 1;

        Swal.fire({
          icon: "info",
          title: "Editando queja",
          text: "Los datos se cargaron en el formulario. Modifica lo necesario y presiona Actualizar.",
          timer: 2200,
          showConfirmButton: false,
        });
      },
      error: (error: any) => {
        this.cargandoEdicion = false;
        const mensaje = error?.error?.error || "No se pudo cargar la queja para editar.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  cancelarEdicion(): void {
    this.modoEdicion = false;
    this.idQuejaEditando = null;
    this.resetearFormularioCreacion();
  }

  // ============ CAMBIO DE ESTADO ============

  cambiarEstado(queja: Queja, estado: number): void {
    const id = Number(queja?.id);
    if (!id) {
      Swal.fire("Error", "No se encontró el id de la queja.", "error");
      return;
    }

    const accion = estado === 1 ? "activar" : "inactivar";
    Swal.fire({
      title: `¿Deseas ${accion} esta queja?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const accionServicio =
        estado === 1 ? this.quejasService.activar(id) : this.quejasService.inactivar(id);

      accionServicio.subscribe({
        next: () => {
          Swal.fire("Éxito", `Queja ${accion}da correctamente.`, "success");
          this.cargarQuejas();
        },
        error: (error: any) => {
          const mensaje = error?.error?.error || `No se pudo ${accion} la queja.`;
          Swal.fire("Error", mensaje, "error");
        },
      });
    });
  }

  // ============ EXPORTAR ============

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
  
verSeguimiento(queja: Queja): void {
  const modalRef = this.modalService.open(SeguimientosQuejasComponent, {
    size: "lg",
    backdrop: "static",
  });
  modalRef.componentInstance.queja = queja;
  modalRef.result.finally(() => this.cargarQuejas());
}
}